import { render, staticRenderFns } from "./ShowClients.vue?vue&type=template&id=272169cb&"
import script from "./ShowClients.vue?vue&type=script&lang=js&"
export * from "./ShowClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports